/**
 * Last-write-wins decision — the single rule both the server (/sync) and the
 * client mirror use to reconcile a record. Times are epoch milliseconds.
 *
 * Returns true when the incoming record should overwrite what's stored. Ties go
 * to the stored value (the receiver keeps what it has), which makes sync
 * convergent and idempotent: replaying the same op never flip-flops.
 */
export function incomingWins(
  incomingMs: number,
  existingMs: number | null | undefined,
): boolean {
  if (existingMs == null) return true;
  return incomingMs > existingMs;
}
